import { Wrapper } from "../components/wrapper";

export default function Sobre(): JSX.Element {
  return (
    <Wrapper className="pt-6 md:pt-20 md:pb-52 pb-12 flex flex-col gap-6">
      <h1 className="text-2xl font-semibold text-primary-900">Privacidade</h1>
      <div className="flex flex-col gap-6 md:flex-row md:justify-stretch">
        <div className="flex-1 text-sm font-normal text-neutral-900 px-6 py-6 flex flex-col gap-4 bg-primary-50 rounded-3xl">
          <h2 className="text-xl font-medium text-primary-700">
            Política de Privacidade do HelpSaude
          </h2>
          <p>
            <p>
              <span className="font-bold">1. Introdução</span> O HelpSaude
              respeita a privacidade dos usuários e está comprometido com a
              proteção dos dados pessoais coletados. Esta política explica como
              tratamos as informações dos prestadores de saúde que decidem se
              registrar e atualizar seus perfis em nossa plataforma.
            </p>
            <p>
              <span className="font-bold">2. Coleta de Dados</span> Não
              coletamos informações pessoais de pacientes. Para prestadores de
              saúde que reivindicam seus perfis, coletamos nome, profissão,
              especialidade, endereço, número de telefone, e-mail e
              identificação médica (CRM).
            </p>
            <p>
              <span className="font-bold">3. Uso dos Dados</span> Os dados dos
              prestadores de saúde são usados para validar a identidade e
              atualizar as informações no perfil.
            </p>
            <p>
              <span className="font-bold">4. Compartilhamento de Dados</span>{" "}
              Não compartilhamos informações pessoais dos prestadores de saúde
              com terceiros. Dados anonimizados podem ser usados para
              publicidade no Google AdSense.
            </p>
            <p>
              <span className="font-bold">5. Direitos dos Usuários</span> Os
              usuários do HelpSaude têm os mesmos direitos que os da Doctoralia,
              adaptados para refletir nossas operações: - Direito de ser
              informado sobre o processamento de seus dados. - Direito de
              apresentar reclamações se considerar que os dados são tratados
              ilegalmente. - Direito de solicitar cópia dos dados pessoais. -
              Direito de pedir exclusão ou correção dos dados pessoais. -
              Direito de se opor ao processamento ou retirar o consentimento. -
              Direito de restringir o processamento dos dados. - Direito à
              portabilidade dos dados.
            </p>
            <p>
              <span className="font-bold">6. Segurança dos Dados</span>{" "}
              Implementamos medidas de segurança para proteger os dados contra
              acesso não autorizado ou violações.
            </p>
            <p>
              <span className="font-bold">
                7. Transferências Internacionais
              </span>{" "}
              Como uma entidade americana, adotamos medidas para garantir a
              proteção adequada dos dados.
            </p>
            <p>
              <span className="font-bold">
                8. Cookies e Tecnologias Semelhantes
              </span>{" "}
              Utilizamos cookies para estatísticas do site e para gerenciar o
              AdSense.
            </p>
            <p>
              <span className="font-bold">
                9. Alterações na Política de Privacidade
              </span>{" "}
              Podemos atualizar esta política para refletir mudanças em nossas
              práticas. Usuários registrados serão notificados por e-mail e a
              data da política será atualizada no site.
            </p>
            <p>
              <span className="font-bold">10. Contato</span> Dúvidas ou questões
              sobre esta política ou sobre os dados pessoais devem ser enviadas
              para contato@helpsaude.com.
            </p>
          </p>
        </div>
      </div>
    </Wrapper>
  );
}
